import { useState } from "react";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";

const CookieBanner = () => {
  const [showCustomize, setShowCustomize] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
  });

  const handleAcceptAll = () => {
    ReactGA.initialize("G-XXXXXXXXXX"); // Replace with actual GA4 ID
    setPreferences({ necessary: true, analytics: true, marketing: true });
  };

  const handleDeclineAll = () => {
    setPreferences({ necessary: true, analytics: false, marketing: false });
  };

  const handleSavePreferences = () => {
    if (preferences.analytics) {
      ReactGA.initialize("G-XXXXXXXXXX"); // Replace with actual GA4 ID
    }
    setShowCustomize(false);
  };

  if (showCustomize) {
    return (
      <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
          <div className="p-6">
            <h2 className="text-2xl font-bold mb-4">Personalizza Cookie</h2>
            <p className="text-gray-600 mb-6">
              Gestisci le tue preferenze sui cookie. Puoi abilitare o disabilitare diverse categorie di cookie.
            </p>

            <div className="space-y-4">
              {/* Necessary Cookies */}
              <div className="border rounded-lg p-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold">Cookie Tecnici Necessari</h3>
                  <span className="text-sm text-gray-500">Sempre attivi</span>
                </div>
                <p className="text-sm text-gray-600">
                  Questi cookie sono essenziali per il funzionamento del sito web e non possono essere disabilitati.
                </p>
              </div>

              {/* Analytics Cookies */}
              <div className="border rounded-lg p-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold">Cookie Analitici</h3>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={preferences.analytics}
                      onChange={(e) => setPreferences({ ...preferences, analytics: e.target.checked })}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                  </label>
                </div>
                <p className="text-sm text-gray-600">
                  Ci aiutano a capire come i visitatori interagiscono con il sito web raccogliendo informazioni in forma anonima.
                </p>
              </div>

              {/* Marketing Cookies */}
              <div className="border rounded-lg p-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold">Cookie di Marketing</h3>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={preferences.marketing}
                      onChange={(e) => setPreferences({ ...preferences, marketing: e.target.checked })}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                  </label>
                </div>
                <p className="text-sm text-gray-600">
                  Utilizzati per mostrare annunci pubblicitari pertinenti ai tuoi interessi.
                </p>
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button
                onClick={handleSavePreferences}
                className="flex-1 bg-primary text-white py-3 px-6 rounded-lg hover:bg-primary/90 transition-colors font-semibold"
              >
                Salva Preferenze
              </button>
              <button
                onClick={() => setShowCustomize(false)}
                className="px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Annulla
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <CookieConsent
      location="bottom"
      buttonText="Accetta Tutti"
      declineButtonText="Rifiuta"
      enableDeclineButton
      onAccept={handleAcceptAll}
      onDecline={handleDeclineAll}
      cookieName="mangimi-rubini-cookie-consent"
      style={{
        background: "linear-gradient(135deg, #2D5016 0%, #3D6B1F 100%)",
        padding: "20px",
        alignItems: "center",
        boxShadow: "0 -4px 20px rgba(0,0,0,0.15)",
      }}
      buttonStyle={{
        background: "#fff",
        color: "#2D5016",
        fontSize: "14px",
        fontWeight: "600",
        borderRadius: "8px",
        padding: "12px 24px",
        margin: "0 8px",
      }}
      declineButtonStyle={{
        background: "transparent",
        color: "#fff",
        fontSize: "14px",
        border: "2px solid #fff",
        borderRadius: "8px",
        padding: "10px 24px",
        margin: "0 8px",
      }}
      expires={365}
    >
      <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="flex-1">
          <p className="text-white text-sm md:text-base">
            Utilizziamo cookie tecnici e, previo tuo consenso, cookie analitici per migliorare la tua esperienza di navigazione.{" "}
            <Link to="/privacy-policy" className="underline hover:text-white/80">
              Privacy Policy
            </Link>
            {" | "}
            <Link to="/cookie-policy" className="underline hover:text-white/80">
              Cookie Policy
            </Link>
          </p>
        </div>
        <button
          onClick={() => setShowCustomize(true)}
          className="text-white text-sm underline hover:text-white/80 whitespace-nowrap"
        >
          Personalizza
        </button>
      </div>
    </CookieConsent>
  );
};

export default CookieBanner;
